import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the FiltroPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'filtro',
})
export class FiltroPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(arreglo: any[], texto: string, columna: string | string[]): any[] {
    if (!texto) return arreglo;
    texto = texto.toLowerCase();
    return arreglo.filter(item => {
      for (let c of Array.isArray(columna) ? columna : [columna])
        if (item[c] && item[c].toLowerCase().includes(texto))
          return true;
      return false;
    });
  }
}



// WEBPACK FOOTER //
// ./src/pipes/filtro/filtro.ts